// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Moment = require("moment");
var Shortid = require("shortid");
var Utils = require("../js/utils");

function generateThumbnail(prim) {
  return Utils.generateThumbnail(prim);
}

function millis(_m) {
  return _m.valueOf();
}

var projectNames = /* array */[
  "Tactician",
  "Harvest Goddess",
  "Nurse Joy"
];

function newProject(name) {
  var thumbnail = {
    name: "thumbnail",
    url: Utils.generateThumbnail(name)
  };
  return {
          id: Shortid.generate(),
          name: name,
          createdDate: Moment().subtract(7, "days").valueOf(),
          targetDate: Moment().add(7, "days").valueOf(),
          budget: 0.0,
          media: /* array */[thumbnail]
        };
}

function newTask(projectID, name) {
  return {
          id: Shortid.generate(),
          projectID: projectID,
          name: name,
          isDone: false,
          description: ""
        };
}

function mockData(param) {
  var projects = $$Array.map(newProject, projectNames);
  var tasks = $$Array.map((function (project) {
          return newTask(project.id, "New Task");
        }), projects);
  return /* tuple */[
          projects,
          tasks
        ];
}

exports.generateThumbnail = generateThumbnail;
exports.millis = millis;
exports.projectNames = projectNames;
exports.newProject = newProject;
exports.newTask = newTask;
exports.mockData = mockData;
/* moment Not a pure module */
